import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { roleQueryKeys, updateRole } from '../api/roles.api';
import type { UpdateRolePayload } from '../types/role.types';

interface UpdateRoleVariables {
  id: number;
  payload: UpdateRolePayload;
}

export function useUpdateRole(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateRoleVariables) => updateRole(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: roleQueryKeys.all() });
      toast.success('Role updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update role');
    },
  });
}
